<div class="ai-chat-view" [class.completed]="completed$()">
  <div class="ai-chat-view__container">
    @for (aiPrompt of questionCtrl().controls; track aiPrompt) {
      <div
        [@inOutAnimation]="'in'"
        class="ai-chat-view__question"
        [scrollToSelected]="'new-message'"
        [class.new-message]="!$first && $last"
        [class.completed]="aiPrompt.value.completed"
      >
        <div class="ai-chat-view__question-icon">
          <fa-icon [icon]="aiPrompt.value.completed ? faCommentCheck : faSparkles"></fa-icon>
        </div>

        <div class="ai-chat-view__question-wrapper">
          @if ($first && stimulusRaw$()) {
            <div class="ai-chat-view__question-wrapper__media">
              <empathy-stimulus [expandable]="true" [stimulus]="[stimulusRaw$()]"></empathy-stimulus>
            </div>
          }
          <span class="survey-viewer__html-content fs__md" [innerHTML]="aiPrompt.value?.questionText || '' | content"></span>
        </div>
      </div>

      @if (processingAudio$() && !aiPrompt.value.answerText) {
        <div [@inOutAnimation]="'in'" class="ai-chat-view__answer audio-mock">
          <fa-icon [icon]="faPlay"></fa-icon>
          <div class="audiowave__mock"></div>
        </div>
      }

      @if (aiPrompt.value.answerText) {
        <!-- [class.audio]="aiPrompt.value.answerAudio" -->
        <div [@inOutAnimation]="'in'" class="ai-chat-view__answer">
          @if (sendFailed$() && $last) {
            <div class="ai-chat-view__question-icon">
              <button mat-icon-button class="eiq-button" color="primary" (click)="onResend()">
                <fa-icon [icon]="faRepeat"></fa-icon>
              </button>
            </div>
          }

          <div class="ai-chat-view__answer-wrapper">
            <!--
              @if (aiPrompt.value.answerAudio) {
                <empathy-audio-chat-card [id]="$index" [data]="urlUtil.createObjectURL(aiPrompt.value.answerAudio)"></empathy-audio-chat-card>
              }
            -->
            <span class="fs__md">{{ aiPrompt.value.answerText }}</span>
          </div>
        </div>
      }

      @if (sendFailed$() && $last) {
        <span class="ai-chat-view__answer__error fs__sm">Failed to send</span>
      }
    }

    @if (waiting$() || processingAudio$()) {
      <div class="ai-chat-view__waiting">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
    }
  </div>

  @if (!completed$() && !waiting$()) {
    <div [@inOutAnimation]="'in'" class="ai-chat-view__footer">
      <!-- (answerAudio)="onAnswerAudio($event)" -->
      <empathy-keyboard-audio
        [context]="audioContext$() | content"
        (answerText)="onAnswer($event)"
        (processing)="processingAudio$.set($event)"
        (transcribeError)="httpError.emit()"
      ></empathy-keyboard-audio>
    </div>
  }
</div>
